import axios from "axios";
import { useState, useEffect } from "react";
import UserTable from "../../Utills/Table/UserTable";
import Switch from "@mui/material/Switch";
import User from "../../components/Modal/User/User";
const UserPage = ({ check, change }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (loading) {
      axios.get("https://tsetsegtuw.templateapi.xyz/users");
      axios
        .get("https://tsetsegtuw.templateapi.xyz/users")
        .then((e) => setUsers(e.data.data))
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [loading]);

  if (loading) {
    return <div className="loader"></div>;
  }

  return (
    <div className="flex flex-col items-center justify-start min-h-screen ml-[18vw] w-[80vw] p-6">

      <div className="w-full flex justify-end mb-4">
        {/* <button
          onClick={() => {
            alert("clicked");
          }}
          className="bg-blue-500 text-white py-2 px-6 rounded-lg transition duration-300 ease-in-out hover:bg-blue-700 focus:ring-2 focus:ring-blue-400 cursor-pointer"
        >
          Хэрэглэгч
        </button> */}
        <Switch
          checked={check}
          onChange={change}
          inputProps={{ "aria-label": "controlled" }}
        />
        <User />
      </div>
      <div className="w-full max-w-7xl">
        <UserTable users={users} />
      </div>
    </div>
  );
};

export default UserPage;
